import { setBearerToken } from '@/http';

export const setHeaderToken = token => setBearerToken(token);
export const getLocalToken = () => localStorage.getItem('token');
export const deleteLocalToken = () => localStorage.removeItem('token');
export const setLocalToken = (token) => {
  if (token == null || token === '') {
    localStorage.removeItem('token');
    return;
  }
  localStorage.setItem('token', token);
};